import React, { useState } from "react"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import { gql, useClient, useQuery } from "hooks/urql"

import ChimeCloudroom from "./Cloudroom"
import JoinCloudroomModal from "./JoinCloudroomModal"

type CloudroomWrapperProps = {
  sessionId: string
  ghost?: boolean
}

const CloudroomWrapper: React.FC<CloudroomWrapperProps> = ({
  sessionId,
  ghost = false,
}) => {
  const [joined, setJoined] = useState<boolean>(false)
  const client = useClient()

  const [joinInfoResult] = useQuery({
    query: joinInfoQuery,
    client,
    variables: { id: sessionId, ghost },
  })

  return joined ? (
    <ChimeCloudroom sessionId={sessionId} ghost={ghost} />
  ) : (
    <WithLoadingIndicator result={joinInfoResult}>
      {({ data: { viewer, airtutorsSession } }) => (
        <JoinCloudroomModal
          ghost={ghost}
          previouslyJoined={!!airtutorsSession.chimeJoinInfo}
          onJoin={() => setJoined(true)}
          viewer={viewer}
          sessionId={sessionId}
        />
      )}
    </WithLoadingIndicator>
  )
}

const joinInfoQuery = gql`
  query joinInfoQuery($id: ID!, $ghost: Boolean!) {
    viewer {
      id
      type
      fullName
      phoneNumber
    }
    airtutorsSession(id: $id) {
      id
      chimeJoinInfo(ghost: $ghost) {
        attendee {
          attendeeId
        }
      }
    }
  }
`

export default CloudroomWrapper
